import React from "react";

const NoticeModal = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60"
      onClick={onClose}
    >
      <div
        className="
          bg-white rounded-xl w-[90vw] max-w-sm p-6
          flex flex-col items-start max-h-[80vh] overflow-y-auto
        "
        onClick={(e) => e.stopPropagation()}
      >
        {/* 내용 */}
        <div className="text-[3.5vw] font-bold space-y-4 px-4 py-6">
          <p style={{ paddingLeft: "1rem", textIndent: "-1rem" }}>
            1. 해당 매출 분석 리포트는 카카오톡을 통해 매일 밤 9시 30분에
            발송됩니다.
          </p>
          <p style={{ paddingLeft: "1rem", textIndent: "-1rem" }}>
            2. 실시간 매출 분석 데이터 리포트 기능은 오픈베타 기간동안에는{" "}
            <span className="font-extrabold">무료로 제공됩니다.</span>
          </p>
          <p style={{ paddingLeft: "1rem", textIndent: "-1rem" }}>
            3. 오픈베타 테스트 기간동안은{" "}
            <span className="font-extrabold">
              비정상적인 데이터 발생이나 서비스 중단 등 간헐적인 문제가 발생할
              수 있으며
            </span>
            , 이로 인해 발생하는 문제에 대해서는 당사가 법적 책임을 지지 않으니
            양해 부탁드립니다.
          </p>
          <p style={{ paddingLeft: "1rem", textIndent: "-1rem" }}>
            4. 해당 서비스는 오픈베타 기간동안 수시로 서비스를 종료할 수 있음을
            알려드립니다.
          </p>
          <p style={{ paddingLeft: "1rem", textIndent: "-1rem" }}>
            5. 매출분석 데이터 리포트에 출력되는 모든 데이터는 정확하지 않을 수
            있으므로 참고만 하시기 바랍니다.
          </p>
        </div>

        <button
          onClick={onClose}
          className="mt-4 self-center text-blue-600 font-semibold"
        >
          확인
        </button>
      </div>
    </div>
  );
};

export default NoticeModal;
